import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import App from './App.vue'
import router from './router'
import Axios from 'axios';
Axios.defaults.baseURL = process.env.APP_ENV == 'development' ? 'http://localhost:3001' : 'https://testfaucetapi.bt.io';

var app=createApp(App)
app.config.globalProperties.Axios=Axios //全局配置axios

app.use(router).use(ElementPlus).mount('#app')

